import { render, staticRenderFns } from "./spreadsheet_documents.vue?vue&type=template&id=70ee7099"
import script from "./spreadsheet_documents.vue?vue&type=script&lang=js"
export * from "./spreadsheet_documents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports